module.exports = __webpack_public_path__ + "img/77dac44.jpg";